import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('+1 (561) 925-7771'); 

  // --- 1. DETECT LOCATION (Phone Number) ---
  useEffect(() => {
    const setContactInfo = async () => {
      try {
        // Switching to 'ipwho.is' which allows browser requests (CORS friendly)
        const response = await fetch('https://ipwho.is/');
        const data = await response.json();
        
        // ipwho.is returns 'country_code' just like the other one
        if (data.country_code === 'BD') {
          setPhoneNumber('+1 (561) 925-7771');
        } else {
          setPhoneNumber('+1 (561) 925-7771');
        }
      } catch (error) {
        console.warn('Location check failed, defaulting to US number.');
        // No need to do anything, default is already set to US
      }
    };
    setContactInfo();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add newsletter subscription logic here
    console.log('Subscribed:', email);
    setEmail('');
  };

  return (
    <footer className="site-footer mt-5">
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <h5>Contact Us</h5>
            <p>Email: info@trustglobal.com.bd</p>
            <p>Phone: {phoneNumber}</p>
          </div>
          <div className="col-md-4">
            <h5>Quick Links</h5>
            <ul className="list-unstyled">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/refund-policy">Refund Policy</Link></li>
              <hr className="border-secondary my-2" />
              <li><a href="https://www.facebook.com/realtrustglobal/" target="_blank" rel="noopener noreferrer">Facebook</a></li>
              <li><a href="http://instagram.com/thetrustglobal/" target="_blank" rel="noopener noreferrer">Instagram</a></li>
            </ul>
          </div>
          <div className="col-md-4">
            <h5>Newsletter</h5>
            <form onSubmit={handleSubmit}>
              <div className="input-group">
                <input 
                  type="email" 
                  className="form-control" 
                  placeholder="Your email" 
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)}
                  required 
                />
                <div className="input-group-append">
                  <button className="btn btn-primary" type="submit">Subscribe</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;